import http from "../../core/services/http.service";

const BidsService = {

  createBid(data) {
    return http.post('/api/v1/bids/', data);
  },

  getBids(params = null, expand = '') {
    return http.get(`/api/v1/bids/?expand=${expand}`, {params});
  },

  updateWinnerBid(data, expand = '') {
    let tempdata = data.force_send ? {force_send: data.force_send} : {};
    tempdata['source_of_sale'] = 'negotiation'
    return http.patch(`/api/v1/bids/mark-as-winner/${data.uuid}/?expand=${expand}`, tempdata);
  },

  deleteLatestBid(data, expand = '') {
    return http.delete(`/api/v1/bids/${data.uuid}/?expand=${expand}`);
  },

  getLivePerformanceBids(params, expand = '') {
    return http.get(`/api/v1/bids/live-performance/?expand=${expand}`, {params});
  }

};

export default BidsService;
